import React from "react";
import "./App.css";
import Spin from "antd/es/spin";
import ClearCache from "react-clear-cache";
import Result from "antd/es/result";
import Button from "antd/es/button";
import { preloadScript } from "opentok-react";
import BlankCache from "./BlankCache";
import Queue from "./components/Queue";
import helper from "./utils/helper";
import RoomVonage from "./RoomVonage";
import Emitter from "./utils/emitter";
import http from "./utils/http";

function VideoCall(props) {
  const [queue, setQueue] = React.useState({ inQueue: 0, queuePosition: 0 });
  const [loading, setLoading] = React.useState(false);
  const [waiting, setWaiting] = React.useState(false);
  const [response, setResponse] = React.useState(null);
  const [sessionHelper, setSessionHelper] = React.useState(null);
  let otSession = React.createRef();

  React.useEffect(() => {
    window.OT.registerScreenSharingExtension(
      "chrome",
      "plocfffmbcclpdifaikiikgplfnepkpo",
      2
    );
    const sid = new URLSearchParams(window.location.search).get("sid");
    if (localStorage.getItem("sid-vonage") || sid) {
      setLoading(true);
      if (parseInt(process.env.REACT_APP_USE_LOCATION) === 1) {
        http.post(
          `${process.env.REACT_APP_API_URL}/${
            process.env.REACT_APP_TENANT
          }/updateLocation?timestamp=${new Date().getMilliseconds()}`,
          {
            sid: sid ? sid : localStorage.getItem("sid-vonage"),
            location: {
              latitude: props.lat,
              longitude: props.long,
            },
          }
        );
      }
      http
        .get(
          `${process.env.REACT_APP_API_URL}/${
            process.env.REACT_APP_TENANT
          }/sessionStatus/${
            sid ? sid : localStorage.getItem("sid-vonage")
          }?timestamp=${new Date().getMilliseconds()}`
        )
        .then((res) => {
          http
            .get(
              `${process.env.REACT_APP_API_URL}/${
                process.env.REACT_APP_TENANT
              }/session/${
                sid ? sid : localStorage.getItem("sid-vonage")
              }?timestamp=${new Date().getMilliseconds()}`
            )
            .then((resp) => {
              setLoading(false);
              resp.data.status = res.data;
              setResponse(resp.data);
              if (res.data === "waiting" || res.data === "initiated") {
                onWait(resp.data);
              } else {
                setSessionHelper({
                  apiKey: resp.data.room.ot.apiKey,
                  sessionId: resp.data.room.sessionId,
                  token: resp.data.token,
                });
              }
            })
            .catch(() => {
              setLoading(false);
              let qp = new URLSearchParams();
              qp.set("sid-vonage", "");
              window.history.replaceState(null, null, "?" + qp.toString());
              localStorage.removeItem("sid-vonage");
            });
        })
        .catch(() => {
          setLoading(false);
          let qp = new URLSearchParams();
          qp.set("sid-vonage", "");
          window.history.replaceState(null, null, "?" + qp.toString());
          localStorage.removeItem("sid-vonage");
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (response) {
      const parameterVidcall = JSON.stringify({
        tenant_id: process.env.REACT_APP_TENANT,
        userid: response?.body?.email,
        type: "customer",
        room: response?.room?.uniqueName,
      });

      const paramsVidcall = helper.encrypt(parameterVidcall);

      let socketVidcall = window.io(process.env.REACT_APP_API_URL, {
        path: `/${process.env.REACT_APP_TENANT}/socket.io`,
        query: { data: paramsVidcall },
        transports: ["websocket"],
      });

      if (response?.status !== "handling") {
        checkQueue(response?.room?.uniqueName);
      }

      const intervalQueue = setInterval(() => {
        if (response?.status !== "handling") {
          checkQueue(response?.room?.uniqueName);
        } else {
          clearInterval(intervalQueue);
        }
      }, 30000);

      socketVidcall.on("accept_video_call", (data) => {
        setLoading(false);
        clearInterval(intervalQueue);
        setWaiting(false);
        setSessionHelper({
          apiKey: response.room.ot.apiKey,
          sessionId: response.room.sessionId,
          token: response.token,
        });
      });

      socketVidcall.on("end_video_call", (data) => {
        endCall();
      });

      socketVidcall.on("newChatVideoCall", (data) => {
        Emitter.emit("MESSAGE_SET", JSON.parse(helper.decrypt(data)));
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response]);

  const onWait = async (resp) => {
    setWaiting(true);
  };

  const endCall = () => {
    otSession?.current?.sessionHelper.disconnect();
    setSessionHelper(null);
    localStorage.removeItem("sid-vonage");
    window.location.href = process.env.REACT_APP_REDIRECT_URL;
  };
  const checkQueue = (sid) => {
    http
      .get(
        `${process.env.REACT_APP_API_URL}/${
          process.env.REACT_APP_TENANT
        }/queuePosition/${sid}?timestamp=${new Date().getMilliseconds()}`
      )
      .then((res) => {
        setQueue(res.data);
      });
  };

  React.useEffect(() => {
    const tidyUp = (event) => {
      if (event.persisted) {
        return;
      }
    };
    window.addEventListener("pagehide", tidyUp);
    window.addEventListener("beforeunload", tidyUp);
    return () => {
      window.removeEventListener("pagehide", tidyUp);
      window.removeEventListener("beforeunload", tidyUp);
    };
  }, []);

  return (
    <Spin spinning={loading} tip="Sedang memproses..." className="h-full">
      {waiting ? (
        <Queue
          setWaiting={setWaiting}
          queue={queue}
          handleLogout={endCall}
          response={response}
          platform={process.env.REACT_APP_PLATFORM}
        />
      ) : sessionHelper && !waiting ? (
        <RoomVonage hangup={endCall} response={response} />
      ) : (
        <Result
          title="Sesi Tidak Valid"
          subTitle="Tidak ada sesi video call berlangsung."
          extra={[
            <Button
              type="primary"
              key="buy"
              onClick={() => {
                window.location.href = process.env.REACT_APP_REDIRECT_URL;
              }}
            >
              Tutup
            </Button>,
          ]}
        />
      )}
    </Spin>
  );
}

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error_name: "",
      error_description: "",
      error_line: "",
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error_name: error.message,
      error_description: errorInfo.componentStack,
      error_line: errorInfo.componentStack.split(":")[0],
    });
  }

  render() {
    return (
      <ClearCache>
        {({ isLatestVersion, emptyCacheStorage }) =>
          !isLatestVersion ? (
            <BlankCache emptyCacheStorage={emptyCacheStorage} />
          ) : (
            <VideoCall {...this.props} />
          )
        }
      </ClearCache>
    );
  }
}

export default preloadScript(App);
